export default {
    'RevokeApiKey': {title: 'Revoke Api Key', icon: 'icon-revoke-api'},
    'UnlockUser': {title: 'Unlock User', icon: 'icon-unlock'},
    'ExpirePassword': {title: 'Expire Password', icon: 'icon-expire'},
    'UnexpirePassword': {title: 'Unexpire Password', icon: 'icon-unexpire'},
    'DeleteUser': {title: 'Delete User', icon: 'icon-clear'}
};


// WEBPACK FOOTER //
// ./constants/user_actions.constants.js